import { gql } from '@apollo/client';

export const CREATE_CHECKOUT_SESSION = gql`
  mutation CreateCheckoutSession($tierId: ID!) {
    createCheckoutSession(tierId: $tierId) {
      url
      sessionId
    }
  }
`;

export const CREATE_PORTAL_SESSION = gql`
  mutation CreatePortalSession {
    createPortalSession {
      url
    }
  }
`;

export const CHANGE_TIER = gql`
  mutation ChangeTier($tierId: ID!) {
    changeTier(tierId: $tierId) {
      url
      sessionId
    }
  }
`;

export const CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscription {
    cancelSubscription {
      _id
      cancelAtPeriodEnd
      currentPeriodEnd
    }
  }
`;

export const REACTIVATE_SUBSCRIPTION = gql`
  mutation ReactivateSubscription {
    reactivateSubscription {
      _id
      cancelAtPeriodEnd
    }
  }
`;

export const PURCHASE_ADDITIONAL_CREDITS = gql`
  mutation PurchaseAdditionalCredits($amount: Int!) {
    purchaseAdditionalCredits(amount: $amount) {
      url
      sessionId
    }
  }
`;

export const CANCEL_PENDING_TIER_CHANGE = gql`
  mutation CancelPendingTierChange {
    cancelPendingTierChange {
      _id
      pendingTier {
        _id
      }
      pendingTierChangeDate
    }
  }
`;
